import React from "react";

export function CheckBox({ checked }) {
  return checked ? (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" stroke="#E3C050" />
      <path
        d="M15.2108 7.03596L14.8504 6.67564C14.7372 6.56233 14.5863 6.5 14.4251 6.5C14.2639 6.5 14.1129 6.56233 13.9997 6.67564L8.93673 11.7385L6.38672 9.20007C6.2735 9.08694 6.12245 9.02452 5.9613 9.02452C5.80023 9.02452 5.64927 9.08694 5.53596 9.20007L5.17556 9.5603C5.06225 9.67379 5 9.82493 5 9.9859C5 10.147 5.06225 10.298 5.17556 10.4113L8.13382 13.3577C8.13856 13.3644 8.14357 13.3707 8.14938 13.3764L8.50979 13.7308C8.62301 13.8437 8.77406 13.9001 8.93646 13.9001H8.93834C9.09959 13.9001 9.25063 13.8437 9.36368 13.7308L9.72417 13.3733C9.72998 13.3676 9.7349 13.3628 9.73785 13.358L15.2107 7.88573C15.4454 7.65151 15.4454 7.27045 15.2108 7.03596Z"
        fill="#E3C050"
      />
    </svg>
  ) : (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="19" height="19" rx="3.5" stroke="#8C8E95" />
    </svg>
  );
}

export default CheckBox;
